import { useState, useEffect } from 'react';
import Axios from 'axios';
import isEmail from 'validator/lib/isEmail';

export const useSnowReportSignup = ({
  endpoint,
  dataTitle,
  defaultSubscriptions = []
}) => {
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [emailAddress, setEmailAddress] = useState('');
  const [isValidFirstName, setIsValidFirstName] = useState(null);
  const [isValidLastName, setIsValidLastName] = useState(null);
  const [isValidEmail, setIsValidEmail] = useState(null);
  const [subscriptions, setSubscriptions] = useState(defaultSubscriptions);
  const [isValid, setIsValid] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [isSubmitButtonDisabled, setIsSubmitButtonDisabled] = useState(null);

  useEffect(() => {
    if (isValidFirstName && isValidLastName && isValidEmail) {
      setIsSubmitButtonDisabled(false);
    } else {
      setIsSubmitButtonDisabled(true);
    }
  }, [isValidFirstName, isValidLastName, isValidEmail]);

  const useFetchData = async () => {
    if (isValidFirstName && isValidLastName && isValidEmail) {
      try {
        const { data } = await Axios({
          method: 'POST',
          url: endpoint,
          data: {
            emailAddress,
            firstName,
            lastName,
            subscriptions
          }
        });
        const { passedValidation, errors, brazeDataLayer } = data;
        setIsValid(passedValidation);
        if (errors.length > 0) setErrorMessage(errors[0].message);

        if (
          passedValidation &&
          brazeDataLayer &&
          Object.keys(brazeDataLayer).length > 0
        ) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: brazeDataLayer.event,
            email: brazeDataLayer.email,
            fname: brazeDataLayer.firstName,
            lname: brazeDataLayer.lastName,
            groups: brazeDataLayer.groups,
            source: document.title,
            form_name: dataTitle
          });

          // Attempt to show secondary opt-in modal if present on page
          const modalEl = document.querySelector(
            '.form-modal[data-module="formModal"]'
          );
          if (modalEl) {
            modalEl.classList.add('form-modal--visible');
          }
        }
      } catch (error) {
        console.error();
      }
    }
  };

  const handleSelectedOptions = value => {
    const selectedOptions = [...subscriptions];

    if (selectedOptions.includes(value)) {
      selectedOptions.splice(selectedOptions.indexOf(value), 1);
    } else {
      selectedOptions.push(value);
    }

    setSubscriptions(selectedOptions);
  };

  const handleFirstNameValue = value => {
    setIsFirstLoad(false);
    setFirstName(value);
    setIsValidFirstName(Boolean(value && value.trim().length > 0));
  };

  const handleLastNameValue = value => {
    setIsFirstLoad(false);
    setLastName(value);
    setIsValidLastName(Boolean(value && value.trim().length > 0));
  };

  const handleEmailValue = value => {
    setIsFirstLoad(false);
    setEmailAddress(value);
    setIsValidEmail(isEmail(value));
  };

  const handleResetForm = () => {
    setIsFirstLoad(true);
    setIsValid(false);
    setFirstName('');
    setLastName('');
    setEmailAddress('');
    setIsValidEmail(false);
    setIsValidFirstName(false);
    setIsValidLastName(false);
    setSubscriptions(defaultSubscriptions);
    setIsSubmitButtonDisabled(false);

    // Remove data-user-typed attribute from all form inputs
    const inputs = [
      'sign-up-report-first-name',
      'sign-up-report-last-name',
      'sign-up-report-email'
    ];

    inputs.forEach(id => {
      const input = document.getElementById(id);
      if (input) {
        input.removeAttribute('data-user-typed');
        // Also remove any autofill/content classes
        input.classList.remove('snow-report-signup__input--autofilled');
        input.classList.remove('snow-report-signup__input--has-content');
      }
    });
  };

  return {
    useFetchData,
    handleFirstNameValue,
    handleLastNameValue,
    handleEmailValue,
    handleSelectedOptions,
    handleResetForm,
    setIsSubmitButtonDisabled,
    isValidFirstName,
    isValidLastName,
    isValidEmail,
    firstName,
    lastName,
    emailAddress,
    isFirstLoad,
    isValid,
    errorMessage,
    isSubmitButtonDisabled,
    subscriptions
  };
};
